<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">401</h1>
          <h4 class="pt-3">Xin lỗi! Đã có vấn đề.</h4>
          <p class="text-muted">Bạn không có quyền truy cập màn hình này</p>
        </div>
        <p class="text">Hãy thử đăng xuất và đăng nhập lại để khắc phục. Nếu vẫn không được, hãy liên hệ với quản trị viên.</p>
        <CButton color="primary" class="px-4" size="large" to="/"><i class="bx bx-home"></i>&nbsp;Quay lại trang chủ</CButton>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page401'
}
</script>
